import qs from 'qs';

export default function parameterSerializer(params: any): any {
  return qs.stringify(params, { arrayFormat: 'repeat' });
}
